import fetchWrapper from "@/api/fetch-wrapper";
import { CALCULATOR_TYPE } from "@/consts";

const defaultParams = {
    type: CALCULATOR_TYPE,
    smsAction: "Y",
}

export const getCancelSmsCodeByPhoneNumber = (phone) => {
    const params = {
        ...defaultParams,
        action: 'send',
        phone
    }

    const query = `/.ajax/order.php`;

    return fetchWrapper.post(query, params);
}

export const submitCancelSmsCode = (code) => {
    const params = {
        ...defaultParams,
        action: 'check',
        code
    }
    const query = `/.ajax/order.php`;
    
    return fetchWrapper.post(query, params);
}

export const submitSubscriptionCancel = (phone, code, cancel_reason) => {
    const params = {
        ...defaultParams,
        action: 'recurrent_cancel',
        code,
        phone,
        cancel_reason
      }
      
    const query = `/.ajax/order.php`;
    
    return fetchWrapper.post(query, params);
}